'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _FileForm = require('../ui/FileForm');

var _FileForm2 = _interopRequireDefault(_FileForm);

var _FileModel = require('../model/FileModel');

var _FileModel2 = _interopRequireDefault(_FileModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditFile = function EditFile(element, args) {
  var _this = this;

  _classCallCheck(this, EditFile);

  this.onchange = function () {
    _this.data = _this.fileForm.getValue();
    window.PRIM.initDelayedNavigation();
    window.PRIM.dataAccess.put('files', _this.data.getJSON()).then(function (file) {
      if (!window.PRIM.isDelayedNavigationActive()) {
        return;
      }

      if (args && !args.id && file.id) {
        window.PRIM.navigate('/files/' + file.id);
        return;
      }

      _this.data.values.id = file.id;
      _this.fileForm.setValue(_this.data);
    }).catch(window.PRIM.exceptionHandler);
  };

  if (args && args.id) {
    window.PRIM.dataAccess.resolve('files', args.id, true).then(function (file) {
      _this.data = file;
      _this.fileForm.setValue(_this.data);
    }, function () {
      if (confirm('Dit bestand bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw bestand aanmaken?')) {
        window.PRIM.navigate('/files/');
      } else {
        history.back();
      }
    }).catch(window.PRIM.exceptionHandler);
  }

  this.data = new _FileModel2.default();

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Bestand bewerken',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/start/');
      },
      icon: '\uE08A'
    }, {
      onclick: this.onchange,
      icon: '\uE020',
      classes: 'indicator'
    }],
    contextMenu: [{
      onclick: function onclick() {
        if (_this.data.values.id) {
          if (confirm('Weet u het zeker dat u  bestand wilt verwijderen?')) {
            window.PRIM.dataAccess.delete('files', _this.data.values.id).then(function () {
              history.back();
            });
          }
        } else {
          alert('Vul eerst gegevens voor dit bestand.');
        }
      },
      icon: '\uE123',
      label: 'Verwijderen'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var divContent = document.createElement('div');
  divContent.className = 'content';

  this.fileForm = new _FileForm2.default(divContent, { file: this.data, onchange: this.onchange });

  div.appendChild(divContent);
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = EditFile;


//////////////////
// WEBPACK FOOTER
// ./js/modules/file/action/EditFile.js
// module id = 72
// module chunks = 0